import React from 'react';
import { zipFile as tooltip } from 'shared/data/tooltips';
import FileComponent from 'shared/components/parameters/FileComponent';

const StencilFile = (props) => {
  const { parameters, required, children } = props;
  const value = parameters.filename;
  const isRequired = value === '' || value === undefined;

  return (
    <div className="form-group">
      <FileComponent
        label="Upload Zip File"
        text="Browse file"
        required={required}
        fileName={value || ''}
        isFileRequired={isRequired}
        {...props} />
      <div id="error_gerber_files" />
      {children}
    </div>
  );
};

StencilFile.defaultProps = {
  required: false,
  tooltip,
};

export default StencilFile;
